// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

<template>
  <detail-view
  :endpoint="endpoint + 'organizations'"
  name="Organization"
  parentRoute="organizations"
  permissions="organizations"
  :values="values"
  ></detail-view>
</template>
<script>
import {ENDPOINT} from '@/shared/constants'
import DetailView from 'vue-common/components/DetailView.vue'

export default {
  components: {
    DetailView
  },

  data () {
    return {
      endpoint: ENDPOINT,
      values: [
        {
          name: 'Basic',
          items: [
            [
              {
                name: 'Name',
                value: 'name',
                required: true
              },
              {
                name: 'Subdomain',
                value: 'subdomain',
                required: true
              },
              {
                name: 'Created Date',
                value: 'timeCreated',
                type: 'date',
                disabled: true
              },
              {
                name: 'Organization Status',
                value: 'status',
                type: 'select',
                context: ENDPOINT + 'orgstatuses',
                itemText: 'text',
                itemValue: 'value'
              }
            ]
          ]
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// OrganizationEdit.vue?580fef9e